import { useLocation } from 'react-router-dom';

import { User } from '../types/auth';
import { getAdminDepartmentIdFromSearch, isAdminUser } from '../utils/adminViewMode';

export const useAdminDepartmentContext = (user?: User | null) => {
  const location = useLocation();
  const adminViewMode = isAdminUser(user);
  const adminDepartmentId = getAdminDepartmentIdFromSearch(location.search);

  return {
    adminViewMode,
    adminDepartmentId: adminViewMode || user === undefined ? adminDepartmentId : null,
  };
};
